import { MOBILE_WIDTH } from "@/constants/layout";
import { colors, Spacing, VStack } from "goi_common";

import { getFlowerOrderDisabledReason } from "../utils";

import { BugoFormBinsoPreview } from "../BugoCreateContainer/components/BugoFormBinsoPreview";
import { BugoIntroSection } from "../BugoCreateContainer/components/BugoIntroSection";
import { useGetObituary } from "../BugoCreateContainer/hooks/useGetObituary";
import { BugoDetailParlorMap } from "./components/BugoDetailParlorMap";
import { BugoDetailSangjuSection } from "./components/BugoDetailSangjuSection";
import { BugoDetailSubmitFixedButtonFooter } from "./components/BugoDetailSubmitFixedButtonFooter";
import { BugoShareVisitorFixedButtonFooter } from "./components/BugoShareVisitorFixedButtonFooter";
import { BugoSangjuMessageSection } from "../BugoCreateContainer/components/BugoSangjuMessageSection";
import { BugoVisitorPostFuneralAlert } from "./components/BugoVisitorPostFuneralBanner";
import { Box } from "@chakra-ui/react";

interface BugoDetailContainerProps {
  shouldEdit: boolean;
  isVisitorType: boolean;
}

export const BugoDetailContainer = ({
  shouldEdit,
  isVisitorType,
}: BugoDetailContainerProps) => {
  const { data: obituary } = useGetObituary();

  const flowerOrderDisabledReason = getFlowerOrderDisabledReason(obituary);

  // 발인 + 7일 게이트 + 임시 키 만료 여부를 백엔드가 단일 계산해 is_expired로 내려준다.
  // 프론트는 시각 비교를 하지 않고 이 값만 보고 만료 화면을 띄운다.
  if (isVisitorType && obituary?.is_expired === true) {
    return (
      <VStack width="100%" alignItems="center">
        <VStack width="100%" css={{ maxWidth: `${MOBILE_WIDTH}px` }}>
          <BugoVisitorPostFuneralAlert />
        </VStack>
      </VStack>
    );
  }

  // TODO: 이놈 왜 화이트인가

  return (
    <VStack width="100%" alignItems="center">
      <VStack
        width="100%"
        css={{
          maxWidth: `${MOBILE_WIDTH}px`,
        }}
      >
        <BugoIntroSection
          readOnly
          isVisitorType={isVisitorType}
          path="visitor"
        />

        {obituary?.custom_message && (
          <>
            <BugoSangjuMessageSection readOnly />
          </>
        )}
        <Box background={colors.warmGray100}>
          <Spacing gap={60} />
          <BugoDetailSangjuSection
            isVisitorType={isVisitorType}
            path="visitor"
          />
          <Spacing gap={60} />

          <BugoFormBinsoPreview readOnly />
          <Spacing gap={60} />

          <BugoDetailParlorMap />
          <Spacing gap={180} />

          {isVisitorType ? (
            <BugoShareVisitorFixedButtonFooter
              flowerOrderDisabledReason={flowerOrderDisabledReason}
              obituary={obituary}
            />
          ) : (
            <BugoDetailSubmitFixedButtonFooter
              isShowModifyButton={shouldEdit}
            />
          )}
        </Box>
      </VStack>
    </VStack>
  );
};
